import { initializeNutasticApp } from '@nutastic/nutastic-react-app';
import { extractElementData, fetchApiData } from '@nutastic/nutastic-react-app/src/utils';
import messages from './i18n/messages';
import App from './components/app/App';
import AppLoading from './components/app/AppLoading';
import WebFont from 'webfontloader';
import AppLoadingAlt from './components/app/AppLoadingAlt';

const init = async () => {
    console.log('initializing website');
    const isHomePage = window.location.pathname.includes('home') || window.location.pathname === '/';

    WebFont.load({
        google: {
            families: [
                'Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900',
                'Poppins:ital,wght@0,100;0,300;0,400;0,600;0,700;0,900;1,100;1,300;1,400;1,600;1,700;1,900'
            ]
        }
    });

    await initializeNutasticApp({
        AppComponent: App,
        LoadingComponent: isHomePage ? AppLoading : AppLoadingAlt,
        loadingDelay: isHomePage ? 2000 : 1500,
        initialState: extractElementData(),
        decorateStateFn: fetchApiData,
        messages,
        reducers: []
    });
};

init();
